import { useLDClient } from 'launchdarkly-react-client-sdk';
import { ALL_TIME_PRESET_FLAG } from '@/utils/constants';

/**
 * Returns `true` when `allTimePreset` is enabled for the current LD context: the selectable date
 * range extends back to 1 January 2014 and downloads over a year are limited to the total
 * breakdown. Despite the name, it no longer adds an "All time" preset.
 * TODO: remove once `allTimePreset` is enabled for everyone, treating it as always `true` at
 * each call site.
 */
const useAllTimePreset = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation(ALL_TIME_PRESET_FLAG, false) ?? false;
};

export default useAllTimePreset;
